import api from "./axios";

/**
 * Withdrawals — real bank transfers via Keepz Direct Settlements.
 *
 * The counterpart to api/checkout.js: that brings money in, this sends it out.
 * @see mintly-back/src/routes/payoutRoutes
 */

/**
 * Where this user's withdrawals go. The IBAN comes back masked — the server never
 * returns it in full.
 * @returns {Promise<{ data: { hasIban: boolean, ibanMasked: string, beneficiaryName: string, identityNumber: string, birthDate: string } }>}
 */
export const getPayoutDetails = async () => {
  const response = await api.get("/payouts/details");
  return response.data;
};

/**
 * Save bank details.
 * @param {{ iban: string, beneficiaryName: string, identityNumber?: string, birthDate?: string }} details
 */
export const savePayoutDetails = async (details) => {
  const response = await api.put("/payouts/details", details);
  return response.data;
};

/**
 * Withdraw to the saved bank account. The balance is debited immediately; a failed
 * transfer is refunded automatically.
 * @param {number} amount
 */
export const requestWithdrawal = async (amount, currency = "GEL") => {
  const response = await api.post("/payouts/withdraw", { amount, currency });
  return response.data;
};

/** Withdrawal history. */
export const getMyPayouts = async () => {
  const response = await api.get("/payouts");
  return response.data;
};

/** Re-check one withdrawal with Keepz. */
export const getPayout = async (payoutId) => {
  const response = await api.get(`/payouts/${payoutId}`);
  return response.data;
};
